import React from 'react'
import { ActivityLogEntry } from '@trustero/trustero-api-web/lib/activity/activity_pb'
import { LogItem } from './LogItem'
import { ChangeLogEntriesProps } from './ChangelogPage.helpers'

export const ChangeLogEntries = ({
  entries,
}: ChangeLogEntriesProps): JSX.Element => {
  const logs = entries.getActivityLogEntriesList()

  return (
    <>
      {logs.map((entry: ActivityLogEntry) => (
        <LogItem key={entry.getId()} logItem={entry} />
      ))}
    </>
  )
}
